<template>
  <section class="benefits-section">
    <div class="full-width-header">{{ header }}</div>
    <div class="content pb-16">
      <div class="benefits-list">
        <div
          class="benefits-item"
          v-for="(item, index) in benefits"
          :key="item.title"
          :class="{ 'benefits-item--reverse': index % 2 === 1 }">
          <div class="benefits-item-content">
            <div class="text-h5 benefits-title">{{ item.title }}</div>
            <div class="text-body-1">{{ item.description }}</div>
          </div>
        </div>
      </div>
      <div class="mt-6 text-center" v-if="bookingUrl">
        <v-btn class="book-now-button" color="primary" size="large" :href="bookingUrl">Book now!</v-btn>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';

interface BenefitItem {
  title: string;
  description: string;
}

export default defineComponent({
  name: 'BenefitsSectionComponent',

  props: {
    header: {
      type: String,
      required: true
    },
    benefits: {
      type: Array as PropType<BenefitItem[]>,
      required: true
    },
    bookingUrl: {
      type: String,
      default: ''
    }
  }
});
</script>

<style scoped lang="scss">
@use '@/styles/typography' as typography;

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1100px;
  margin: 0 auto 16px;
}

.benefits-item {
  display: flex;
  justify-content: flex-start;
  padding: 32px 40px;
  background: rgba(var(--v-theme-primary), 0.06);
  border-radius: 18px;
  border-left: 3px solid rgba(var(--v-theme-primary), 0.8);
}

.benefits-item--reverse {
  justify-content: flex-end;
  border-left: none;
  border-right: 3px solid rgba(var(--v-theme-primary), 0.8);
  text-align: right;
}

.benefits-item-content {
  max-width: 65%;
}

.benefits-title {
  margin-bottom: 8px;
  // font-family: typography.$heading-font;
  font-size: 28px !important;
}

@media (max-width: 768px) {
  .benefits-item,
  .benefits-item--reverse {
    padding: 24px 20px;
  }

  .benefits-item-content {
    max-width: 100%;
  }
}
</style>
